import { createContext, useContext, useState, useEffect } from 'react';
import { CURRENCIES, fmtPrice } from '../lib/currency';

const DEFAULT = {
  idx: 0,
  currency: { code:'INR', symbol:'₹', rate:1, label:'₹ INR' },
  cycle: ()=>{},
  fmt: (n) => '₹' + Number(n).toLocaleString('en-IN'),
};

const CurrencyContext = createContext(DEFAULT);

export function CurrencyProvider({ children }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const s = localStorage.getItem('aurora_currency');
    if (s !== null) setIdx(Number(s));
  }, []);

  function cycle() {
    setIdx((prev) => {
      const next = (prev + 1) % CURRENCIES.length;
      localStorage.setItem('aurora_currency', String(next));
      return next;
    });
  }

  const fmt = (inrAmount) => fmtPrice(inrAmount, idx);

  return (
    <CurrencyContext.Provider value={{ idx, currency: CURRENCIES[idx], cycle, fmt }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() { return useContext(CurrencyContext); }